var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.cadastro.informacaoDesejada
    ? _c(
        "div",
        { staticClass: "marginTop" },
        [
          _c(
            "el-row",
            { attrs: { type: "flex", gutter: 30 } },
            [
              _c(
                "el-col",
                { staticClass: "container-input", attrs: { md: 12, sm: 24 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: "required",
                      name: "Tipo informação desejada",
                      mode: "lazy"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("app-label", {
                                attrs: {
                                  label:
                                    "Selecione o tipo de informação desejada:",
                                  required: true
                                }
                              }),
                              _c(
                                "el-select",
                                {
                                  staticClass: "input select",
                                  class: { erro: errors.length },
                                  attrs: {
                                    placeholder: "Selecione",
                                    "value-key": "codigo",
                                    name: "tipoInformacao"
                                  },
                                  model: {
                                    value:
                                      _vm.cadastro.informacaoDesejada
                                        .tipoInformacao,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.cadastro.informacaoDesejada,
                                        "tipoInformacao",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "cadastro.informacaoDesejada.tipoInformacao"
                                  }
                                },
                                _vm._l(_vm.tiposInformacao, function(item) {
                                  return _c("el-option", {
                                    key: item.codigo,
                                    attrs: {
                                      label: item.descricao,
                                      value: item
                                    }
                                  })
                                }),
                                1
                              ),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1319170887
                    )
                  })
                ],
                1
              ),
              _vm.cadastro.informacaoDesejada.tipoInformacao &&
              _vm.cadastro.informacaoDesejada.tipoInformacao.codigo == "OUTRO"
                ? _c(
                    "el-col",
                    { staticClass: "container-input", attrs: { span: 16 } },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: { label: "Descrição:" }
                                  }),
                                  _c("el-input", {
                                    staticClass: "input",
                                    class: { erro: errors.length },
                                    attrs: {
                                      name: "Descrição",
                                      maxlength: "300"
                                    },
                                    model: {
                                      value:
                                        _vm.cadastro.informacaoDesejada
                                          .descricaoOutro,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.cadastro.informacaoDesejada,
                                          "descricaoOutro",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "cadastro.informacaoDesejada.descricaoOutro"
                                    }
                                  }),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          797017723
                        )
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "container-input" },
            [
              _c("validation-provider", {
                attrs: {
                  rules: "required",
                  name: "Justificativa",
                  mode: "eager"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var errors = ref.errors
                        return [
                          _c("app-label", {
                            attrs: {
                              label: "Justificativa de solicitação:",
                              required: true
                            }
                          }),
                          _c("app-text-editor", {
                            class: {
                              "input erro":
                                errors && errors.length > 0 ? true : false
                            },
                            attrs: { config: _vm.config },
                            model: {
                              value:
                                _vm.cadastro.informacaoDesejada.justificativa,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.cadastro.informacaoDesejada,
                                  "justificativa",
                                  $$v
                                )
                              },
                              expression:
                                "cadastro.informacaoDesejada.justificativa"
                            }
                          }),
                          _c("span", { staticClass: "help erro" }, [
                            _vm._v(_vm._s(errors[0]))
                          ])
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2285409956
                )
              })
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e3bc036c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3bc036c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/cadastros/para/solicitarInformacao/components/InformacaoDesejada.vue
// module id = null
// module chunks = 